export default __webpack_public_path__ + "static/media/banner-3.ae137e3e.jpeg";